export const FsEntryPickerTestIdFactory = {
    getCurrentDirSelectTestId: (testId) => `${testId}-select-current`,
    getEntrySelectTestId: (testId, entryId) => `${testId}-select-${entryId}`,
};
